export default {
  namespaced: true,
  state: {
    preloader: false,
    routeLoading: false,
  },
  getters: {
    preloader(state) {
      return state.preloader;
    },
    routeLoading(state) {
      return state.routeLoading;
    },
  },
  mutations: {
    preloader(state, payload) {
      state.preloader = payload;
    },
    routeLoading(state, payload) {
      state.routeLoading = payload;
    },
  },
  actions: {
    setRouteLoading({ commit }, isLoading) {
      commit("routeLoading", isLoading);
    },
  },
};
